import React, { useEffect } from 'react';
import { Navbar } from './components/Navbar';
import { Hero } from './components/Hero';
import { WhenToBringMeIn } from './components/WhenToBringMeIn';
import { Experience } from './components/Experience';
import { WorkingTogether } from './components/WorkingTogether';
import { About } from './components/About';
import { Contact } from './components/Contact';
import { Footer } from './components/Footer';
import { initAnalytics } from './utils/analytics';
import { useSectionViews } from './hooks/useSectionViews';
function setMetaTag(name: string, content: string) {
  let meta = document.querySelector<HTMLMetaElement>(`meta[name="${name}"]`);
  if (!meta) {
    meta = document.createElement('meta');
    meta.name = name;
    document.head.appendChild(meta);
  }
  meta.content = content;
}
export function App() {
  // Initialize analytics first so the section observer's events have a tag to send to
  useEffect(() => {
    initAnalytics();
  }, []);
  useSectionViews();
  useEffect(() => {
    document.title = 'Thomas Consulting | Craig Thomas, Fractional Transformation Executive';
    const description = 'Portland-based executive consultant helping organizations turn strategy into action, strengthen operations, and develop leaders through focused, part-time engagements.';
    setMetaTag('description', description);
    setMetaTag('google-site-verification', 'RfdZE5TNIQ-5WnqRvThH644_E4sK0ICWKjPl8GBRHP8');
  }, []);
  return <div className="w-full min-h-screen bg-paper text-ink font-sans overflow-x-hidden" data-id="element-0" data-mp="2zmwl5831y4h0">
      <Navbar data-id="element-1" data-mp="33n6w6z5pbl2q" />
      <main data-id="element-2" data-mp="33orki71fa7s5">
        <Hero data-id="element-3" data-mp="38lrp0dimj2h5" />
        <WhenToBringMeIn data-id="element-4" data-mp="38m1jadapbvsn" />
        <Experience data-id="element-5" data-mp="38kqafz2efxuo" />
        <WorkingTogether data-id="element-6" data-mp="38k6x6vnp1xmz" />
        <About data-id="element-7" data-mp="38o4f5dyjcj5a" />
        <Contact data-id="element-8" data-mp="3dkl5met7j9lj" />
      </main>
      <Footer data-id="element-9" data-mp="3dlw4c07spr5s" />
    </div>;
}